<template>
  <div v-if="domains">
    <title-model-a :title="`Dominios asociados ${domains.length}`" icon="info" />

    <v-expansion-panels v-model="openPanels" class="mt-2" multiple>
      <v-expansion-panel
        v-for="(domain, index) in domains"
        :key="index"
        class="mb-2"
      >
        <v-expansion-panel-header>
          <template v-slot:default>
            <v-list-item two-line>
              <v-list-item-content class="py-0">
                <v-list-item-title class="cb-font-size-subtitle pb-2">
                  {{ domain.name }}
                </v-list-item-title>

                <v-list-item-subtitle>
                  <span
                    v-for="(variable, idx) in statusVariables"
                    :key="idx"
                  >
                    <v-icon
                      :color="domain[variable.key] ? 'success' : 'error'"
                      class="mr-1"
                      small
                    >
                      {{ domain[variable.key] ? "check" : "warning" }}
                    </v-icon>
                    <span
                      :class="domain[variable.key] ? 'success--text' : 'error--text'"
                      class="font-weight-medium"
                      style="vertical-align: middle;"
                    >
                      {{ variable.text }}
                    </span>
                    <span
                      v-if="idx !== statusVariables.length - 1"
                      class="mx-2 cb-font-size-2 grey--text"
                      style="vertical-align: text-bottom;"
                    >
                      |
                    </span>
                  </span>
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <button-icon-text-model-b
                  :disabled="!isAccount"
                  icons="send"
                  text="Enviar semillas"
                  @click="$emit('send-seeds', domain.name)"
                />
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <v-simple-table class="my-4" dense>
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left" style="max-width: 30%; width: 30%">Clave</th>
                <th class="text-left">Valor</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(value, key) in domain" :key="key">
                <td style="max-width: 30%; width: 30%">{{ key }}</td>
                <td>
                    <span
                      v-if="typeof value === 'boolean'"
                      :class="value ? 'success--text' : 'error--text'"
                      class="font-weight-bold align_vertical_center"
                    >
                      <v-icon v-if="!value" class="mr-1" color="error" small>
                        warning
                      </v-icon>
                      {{ value ? "OK" : "FAIL" }}
                    </span>

                  <v-col v-else-if="key === 'returnPathInfo'" class="pa-0">
                    <v-jsoneditor
                      :options="jsonEditorOptions"
                      :value="JSON.parse(value)"
                      height="400px"
                    />
                  </v-col>

                  <span v-else style="word-break: break-all;">
                      {{ value }}
                    </span>
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import TitleModelA from "@/components/repository/TitleModelA.vue";
import ButtonIconTextModelB from "@/components/repository/buttons/ButtonIconTextModelB.vue";

const DOMAIN_STATUS_VARIABLES = [
  { key: "DKIMIs2048", text: "Clave 2048" },
  { key: "DKIMStatus", text: "DKIM" },
  { key: "SPFStatus", text: "SPF" },
  { key: "DMARCStatus", text: "DMARC" },
  { key: "googlePostmasterStatus", text: "Google Postmaster" },
  { key: "delegationStatus", text: "Delegación" },
  { key: "returnPathStatus", text: "Return Path" }
];

export default {
  name: "DomainResultsList",
  components: {
    TitleModelA,
    ButtonIconTextModelB
  },
  props: {
    isAccount: Boolean,
    domains: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      openPanels: [],
      statusVariables: DOMAIN_STATUS_VARIABLES,
      jsonEditorOptions: {
        mode: "code",
        mainMenuBar: false,
        statusBar: false
      }
    };
  }
};
</script>
